var map = {
	"./TIBAGI/logos/brasao.png": 4032,
	"./TIBAGI/logos/logo_2.png": 8746,
	"./alvorada/logos/brasao.png": 5324,
	"./alvorada/logos/logo.png": 7184,
	"./bom_sucesso/logos/brasao.png": 2168,
	"./bom_sucesso/logos/logo.png": 9898,
	"./carambei/logos/brasao.png": 153,
	"./carambei/logos/logo2.png": 1198,
	"./castro.png": 7768,
	"./imbau/logos/brasao.png": 3856,
	"./imbau/logos/brasao2.png": 1477,
	"./ipiranga/logos/brasao.png": 189,
	"./ipiranga/logos/logo.png": 8494,
	"./jacarezinho/logos/brasao.png": 1731,
	"./jacarezinho/logos/logo.png": 4370,
	"./jaguariaiva/logos/brasao.png": 3573,
	"./jaguariaiva/logos/logo.png": 7836,
	"./marilandia/logos/bandeira.jpg": 3821,
	"./marilandia/logos/brasao.png": 841,
	"./ortigueira/logos/brasao.png": 9031,
	"./ortigueira/logos/logo.png": 2021,
	"./palmeira/leis/ANEXO_1.pdf": 4550,
	"./palmeira/leis/ANEXO_2.pdf": 1450,
	"./palmeira/logos/brasao.png": 8767,
	"./palmeira/logos/prefeitura_municipal.png": 5891,
	"./palmeira/logos/secretaria_urbanismo.jpeg": 3676,
	"./senges/logos/logo.png": 8736,
	"./tamarana/logos/logo_tamarana.png": 8598,
	"./ventania/logos/brasao.png": 632,
	"./ventania/logos/logo.png": 378
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1726;